import { APP_URL } from '../../constants';
import { MARKETS } from '../../data/markets';
import { useLanguage } from '../../i18n/LanguageContext';
import { asset } from '../../lib/asset';

function LifestyleSection() {
    const { t } = useLanguage();

    return (
        <section className="home-sec lifestyle" id="everyday">
            <div className="wrap">
                <div className="launch-head lifestyle-head rv">
                    <div>
                        <span className="eyebrow">{t.everydayEyebrow}</span>
                        <h2>{t.everydayTitle}</h2>
                    </div>
                    <p>{t.everydayLead}</p>
                </div>
                <div className="lifestyle-grid">
                    <a className="life-card life-wide rv" href={APP_URL} style={{ '--rv-delay': '0ms' }}>
                        <img
                            src={asset('lifestyle-giftcard.png')}
                            width="1536"
                            height="1024"
                            alt={t.lifeGiftAlt}
                            loading="lazy"
                        />
                        <span className="life-shade" />
                        <span className="life-copy">
                            <small>{t.lifeGiftEyebrow}</small>
                            <b>{t.lifeGiftTitle}</b>
                            <em>{t.lifeGiftCta}</em>
                        </span>
                    </a>
                    <a className="life-card rv" href={APP_URL} style={{ '--rv-delay': '80ms' }}>
                        <img src={asset('lifestyle-esim.png')} width="1536" height="1024" alt={t.lifeEsimAlt} loading="lazy" />
                        <span className="life-shade" />
                        <span className="life-copy">
                            <small>{t.lifeEsimEyebrow}</small>
                            <b>{t.lifeEsimTitle}</b>
                            <em>{t.lifeEsimCta}</em>
                        </span>
                    </a>
                    <a className="life-card rv" href={APP_URL} style={{ '--rv-delay': '160ms' }}>
                        <img src={asset('lifestyle-travel.png')} width="1536" height="1024" alt={t.lifeTravelAlt} loading="lazy" />
                        <span className="life-shade" />
                        <span className="life-copy">
                            <small>{t.lifeTravelEyebrow}</small>
                            <b>{t.lifeTravelTitle}</b>
                            <em>{t.lifeTravelCta}</em>
                        </span>
                    </a>
                </div>
                <section className="market-atlas panel rv" aria-labelledby="marketTitle">
                    <div className="market-atlas-head">
                        <div>
                            <span className="eyebrow">{t.marketEyebrow}</span>
                            <h3 id="marketTitle">{t.marketTitle}</h3>
                        </div>
                        <p>{t.marketLead}</p>
                    </div>
                    <ul className="flag-grid" aria-label={t.marketGridLabel}>
                        {MARKETS.map((m) => (
                            <li className="flag-tile" key={m.code}>
                                <img
                                    src={asset(`flags/${m.code}.svg`)}
                                    width="48"
                                    height="36"
                                    alt=""
                                    loading="lazy"
                                    decoding="async"
                                />
                                <span className="sr-only">{m.name}</span>
                            </li>
                        ))}
                    </ul>
                    <p className="market-note" id="marketNote">
                        <span aria-hidden="true">
                            i
                        </span>
                        {t.marketNote}
                    </p>
                </section>
            </div>
        </section>
    );
}

export default LifestyleSection;
